import { render, staticRenderFns } from "./savePhoto.vue?vue&type=template&id=72d6b8c6&"
import script from "./savePhoto.vue?vue&type=script&lang=js&"
export * from "./savePhoto.vue?vue&type=script&lang=js&"
import style0 from "./savePhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports